export default __webpack_public_path__ + "static/media/CreditCardImage.bd537d29.svg";